module.exports = __webpack_public_path__ + "static/img/hero.1e14267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hero.png
// module id = OLZT
// module chunks = 1